module.exports = __webpack_public_path__ + "img/gsb55.71217a8e.png";